import {
  Component, Input, Output, EventEmitter, OnChanges, OnDestroy, AfterViewInit,
  ViewChild, ElementRef, ViewEncapsulation, inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  RawBucket, RecentControlVm,
  rollUpBuckets, fillGaps, regulZoom,
  fmtM, fmtH, fmtD, fmt,
  Granularity, TimelineDisplay, MAX_M, MAX_H, MAX_D,
} from '../tableau-de-bord.types';
import { Router } from '@angular/router';

interface BarEntry { count: number; cumul: number; date: string; }
interface BarSet { bars: BarEntry[]; maxCount: number; }
type SeriesKey = 'S' | 'In' | 'Out';

@Component({
  selector: 'app-dashboard-timeline',
  standalone: true,
  imports: [FormsModule],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="bloc b6 ui-card"
         (mouseup)="onB6Up()" (touchend)="onB6Up()">

      <div class="titgraph">
        <i class="fa-duotone fa-light fa-chart-area icduotone"></i>&nbsp; Suivi
        <select class="selectb6" style="display:inline;"
                [ngModel]="typGraph" (ngModelChange)="onTypGraphChange($event)">
          <option value="In">des entrées</option>
          <option value="Out">des sorties</option>
          <option value="S">de l'affluence</option>
        </select>
      </div>

      <div class="btnrefreshT" (click)="onRefresh()">
        <i class="fas fa-sync-alt"></i>
      </div>

      <div class="mtnpay">
        <span class="txtmtnpay" style="font-weight:400;font-size:15px;opacity:0.6;">{{ txtmtnpay }}</span>
        <br>
        <span [innerHTML]="mtndatapay"></span>
      </div>

      <div class="contzoom"
           (mousemove)="onZoomMouseMove($event)" (touchmove)="onZoomTouchMove($event)">
        <div class="contslidZoom">
          <div class="sliderZoom">
            <div class="sliderhandZoom"
                 [style.margin-top.px]="sliderTop"
                 (mousedown)="onSliderDown($event)"
                 (touchstart)="onSliderTouchStart($event)">
            </div>
          </div>
        </div>
        <div class="iczoomMoins"><i class="fas fa-search"></i></div>
      </div>

      <div class="labZoom" [style.margin-top.px]="sliderTop" style="opacity:0">
        <div class="txtlabZoom">{{ zoomLabel }}</div>
        <div class="iclabZoom"><i class="fas fa-caret-right"></i></div>
      </div>

      <div class="contgraphT" #contgraphT
           (scroll)="onGraphScroll()"
           (mouseover)="onGraphMouseOver()"
           (mouseout)="onGraphMouseOut()">

        <div class="graphT gTJ"
             [style.display]="activeGran === 'J' ? 'flex' : 'none'"
             [style.width.px]="graphWidthD">
          @for (bar of activeBarsD; track $index; let i = $index) {
            <div class="barG"
                 [style.width]="barWidthPct(activeBarsD.length)"
                 style="height:100%;transform:scale(1.0,1.0)"
                 (mouseenter)="onBarEnter(bar, i, $event)"
                 (mouseleave)="onBarLeave()">
              <div class="g"
                   [style.height]="barHeightPct(bar.count, activeMaxD)"
                   [style.background-image]="barGradient(i)"
                   style="width:96%;margin-left:2%">
              </div>
            </div>
          }
        </div>

        <div class="graphT gTH"
             [style.display]="activeGran === 'H' ? 'flex' : 'none'"
             [style.width.px]="graphWidthH">
          @for (bar of activeBarsH; track $index; let i = $index) {
            <div class="barG"
                 [style.width]="barWidthPct(activeBarsH.length)"
                 style="height:100%;transform:scale(1.0,1.0)"
                 (mouseenter)="onBarEnter(bar, i, $event)"
                 (mouseleave)="onBarLeave()">
              <div class="g"
                   [style.height]="barHeightPct(bar.count, activeMaxH)"
                   [style.background-image]="barGradient(i)"
                   style="width:90%;margin-left:5%">
              </div>
            </div>
          }
        </div>

        <div class="graphT gTM"
             [style.display]="activeGran === 'M' ? 'flex' : 'none'"
             [style.width.px]="graphWidthM">
          @for (bar of activeBarsM; track $index; let i = $index) {
            <div class="barG"
                 [style.width]="barWidthPct(activeBarsM.length)"
                 style="height:100%;transform:scale(1.2,1.0)"
                 (mouseenter)="onBarEnter(bar, i, $event)"
                 (mouseleave)="onBarLeave()">
              <div class="g"
                   [style.height]="barHeightPct(bar.count, activeMaxM)"
                   [style.background-image]="barGradient(i)"
                   style="width:100%;margin-left:0%">
              </div>
            </div>
          }
        </div>

        <div class="ndg noDataGs"   [style.display]="dlg === 0 && typGraph === 'S'   ? 'flex' : 'none'">
          <i class="fa-solid fa-chart-simple" style="opacity:0.7;font-size:28px"></i><br><br>
          Aucune donnée de contrôle
        </div>
        <div class="ndg noDataGin"  [style.display]="dlg === 0 && typGraph === 'In'  ? 'flex' : 'none'">
          <i class="fa-solid fa-chart-simple" style="opacity:0.7;font-size:28px"></i><br><br>
          Aucune donnée d'entrée
        </div>
        <div class="ndg noDataGout" [style.display]="dlg === 0 && typGraph === 'Out' ? 'flex' : 'none'">
          <i class="fa-solid fa-chart-simple" style="opacity:0.7;font-size:28px"></i><br><br>
          Aucune donnée de sortie
        </div>
      </div>

      <div class="contlistpay">
        <div class="titlistpay">
          <i class="fa-regular fa-clock-rotate-left"></i> &nbsp;
          <span class="respdis15">{{ respdis15 }}</span>
          <span class="respvis15">Récents </span>:
        </div>
        <div class="listpay">
          @if (dlg === 0) {
            <div class="nolastc" [innerHTML]="noDataMsg"></div>
          } @else {
            @for (item of listpayItems; track $index) {
              <div [class]="item.cls">
                <div class="typels">
                  @if (item.isIn) {
                    <i class="fa-solid fa-arrow-up-to-line" style="transform:rotate(90deg)"></i>
                  } @else {
                    <i class="fa-solid fa-arrow-up-from-line" style="transform:rotate(-90deg)"></i>
                  }
                </div>
                <div class="namels">{{ item.nomEtPrenom }}</div>
                <div class="tplls">{{ item.tplName }}</div>
                <div class="datels">{{ item.dateStr }}</div>
              </div>
            }
            <div [class]="listpayTrailingCls"></div>
          }
        </div>
      </div>

      <div class="btngoparT ui-btn ui-btn--primary ui-btn--sm ui-btn--block ui-btn--auto"
           (click)="onGoParticipants()">
        <i class="far fa-list"></i> &nbsp;<span class="respdis9">Liste des </span>participants
      </div>
    </div>
  `,
})
export class DashboardTimelineComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() minuteBuckets: RawBucket[] = [];
  @Input() totalSTxt  = '0';
  @Input() totalInTxt = '0';
  @Input() totalOutTxt = '0';
  @Input() totSPer  = '0';
  @Input() totInPer = '0';
  @Input() totOutPer = '0';
  @Input() toScan   = 0;
  @Input() totS     = 0;
  @Input() totOut   = 0;
  @Input() toScanTxt = '0';
  @Input() totIn    = 0;
  @Input() cgs      = 0;
  @Input() recentS:   RecentControlVm[] = [];
  @Input() recentIn:  RecentControlVm[] = [];
  @Input() recentOut: RecentControlVm[] = [];
  @Input() overmax: number = 0;

  /** Emitted when typGraph changes so parent can sync b2 (donut) display. */
  @Output() displayChange = new EventEmitter<TimelineDisplay>();
  @Output() refresh = new EventEmitter<void>();

  private readonly router = inject(Router);

  // ── Series data ────────────────────────────────────────────────────────────
  private series: Record<SeriesKey, { M: BarSet; H: BarSet; D: BarSet }> = {
    S:   { M: { bars: [], maxCount: 1 }, H: { bars: [], maxCount: 1 }, D: { bars: [], maxCount: 1 } },
    In:  { M: { bars: [], maxCount: 1 }, H: { bars: [], maxCount: 1 }, D: { bars: [], maxCount: 1 } },
    Out: { M: { bars: [], maxCount: 1 }, H: { bars: [], maxCount: 1 }, D: { bars: [], maxCount: 1 } },
  };

  // ── Active view state ──────────────────────────────────────────────────────
  typGraph: SeriesKey = 'In';
  dlg = 0;
  activeGran: Granularity | 'N' = 'M';
  zoomLabel = 'Minutes';
  graphWidthM = 0;
  graphWidthH = 0;
  graphWidthD = 0;
  activeBarsM: BarEntry[] = [];
  activeBarsH: BarEntry[] = [];
  activeBarsD: BarEntry[] = [];
  activeMaxM = 1;
  activeMaxH = 1;
  activeMaxD = 1;

  // ── Display values (also emitted to parent for b2 sync) ───────────────────
  mtndatapay = '0';
  txtmtnpay  = 'Total :';
  respdis15  = 'Dernières entrées ';
  listpayItems: { cls: string; isIn: boolean; nomEtPrenom: string; tplName: string; dateStr: string }[] = [];
  listpayTrailingCls = 'itpay itpayg';
  noDataMsg  = '';

  // ── Slider state ───────────────────────────────────────────────────────────
  private readonly DEF = 35;
  sliderTop = 35;
  private vi = 35;
  private pm = 0;
  private wiG = 0;
  private defsize = 0;
  private lastsize = 0;
  private tox = 0;
  private wicgt = 0;
  private lastmt = 35;

  // ── Hover state ────────────────────────────────────────────────────────────
  private hoveredIdx = -1;
  private defsl = 0;

  @ViewChild('contgraphT') contgraphRef?: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    this.applyGraphScroll();
  }

  ngOnChanges(): void {
    this.buildAllSeries();
    this.genG(this.typGraph);
  }

  ngOnDestroy(): void { /* no intervals/timers to clear */ }

  // ── Series building ────────────────────────────────────────────────────────

  private buildBarSet(
    buckets: RawBucket[],
    type: 's' | 'in' | 'out',
    step: number,
    fmtFn: typeof fmtM,
    maxEntries: number,
  ): BarSet {
    const bars: BarEntry[] = [];
    let runningCount = 0;
    let cumul = 0;
    let entries = 0;
    for (let i = 0; i < buckets.length; i++) {
      if (entries >= maxEntries) break;
      if (i > 0) {
        const gaps = fillGaps(buckets[i - 1], buckets[i], step, fmtFn, maxEntries, entries);
        for (const gapDate of gaps) {
          // Gap bars: for 's' keep running count, for in/out count=0
          const cnt = type === 's' ? runningCount : 0;
          bars.push({ count: cnt, cumul: type === 's' ? runningCount : cumul, date: gapDate });
          entries++;
        }
      }
      if (entries >= maxEntries) break;
      if (type === 's') {
        runningCount += buckets[i].in - buckets[i].out;
        cumul = runningCount;
      } else if (type === 'in') {
        runningCount = buckets[i].in;
        cumul += runningCount;
      } else {
        runningCount = buckets[i].out;
        cumul += runningCount;
      }
      bars.push({ count: runningCount, cumul, date: fmtFn(buckets[i]) });
      entries++;
    }
    const maxCount = bars.reduce((m, b) => Math.max(m, b.count), 0) || 1;
    return { bars, maxCount };
  }

  private buildAllSeries(): void {
    const min = this.minuteBuckets;
    if (!min.length) {
      this.series = {
        S:   { M: { bars: [], maxCount: 1 }, H: { bars: [], maxCount: 1 }, D: { bars: [], maxCount: 1 } },
        In:  { M: { bars: [], maxCount: 1 }, H: { bars: [], maxCount: 1 }, D: { bars: [], maxCount: 1 } },
        Out: { M: { bars: [], maxCount: 1 }, H: { bars: [], maxCount: 1 }, D: { bars: [], maxCount: 1 } },
      };
      return;
    }
    const hour = rollUpBuckets(min, 'H');
    const day  = rollUpBuckets(min, 'J');
    this.series = {
      S:   { M: this.buildBarSet(min, 's',   60_000,     fmtM, MAX_M), H: this.buildBarSet(hour, 's',   3_600_000,  fmtH, MAX_H), D: this.buildBarSet(day, 's',   86_400_000, fmtD, MAX_D) },
      In:  { M: this.buildBarSet(min, 'in',  60_000,     fmtM, MAX_M), H: this.buildBarSet(hour, 'in',  3_600_000,  fmtH, MAX_H), D: this.buildBarSet(day, 'in',  86_400_000, fmtD, MAX_D) },
      Out: { M: this.buildBarSet(min, 'out', 60_000,     fmtM, MAX_M), H: this.buildBarSet(hour, 'out', 3_600_000,  fmtH, MAX_H), D: this.buildBarSet(day, 'out', 86_400_000, fmtD, MAX_D) },
    };
  }

  // ── genG : display switch (iso legacy) ────────────────────────────────────

  /** Builds the {titb2, mper, mtntot, texttotparT} display object for a given series. */
  private computeDisplay(typGraph: SeriesKey): TimelineDisplay {
    let titb2 = '', mper = '', mtntot = '', texttotparT = '';
    let d1 = 0, d2 = 0;
    if (typGraph === 'S') {
      d1 = this.totS; d2 = this.toScan - this.totS;
      titb2 = 'Taux<span class="respdis13"> de présence</span>';
      texttotparT = this.toScan > 1
        ? `${this.toScanTxt}<span class="respdis14"> contrôles</span>`
        : `${this.toScanTxt}<span class="respdis14"> contrôle</span>`;
      mper   = this.cgs === 0 ? this.totSPer   : this.totalSTxt;
      mtntot = this.cgs === 0 ? this.totalSTxt : `${this.totSPer}<span style="font-size:14px;"> %</span>`;
    } else if (typGraph === 'In') {
      d1 = this.totIn; d2 = this.toScan - this.totIn;
      titb2 = 'Nombre<span class="respdis13"> d\'entrées</span>';
      texttotparT = this.toScan > 1
        ? `${this.toScanTxt}<span class="respdis14"> contrôles</span>`
        : `${this.toScanTxt}<span class="respdis14"> contrôle</span>`;
      mper   = this.cgs === 0 ? this.totInPer  : this.totalInTxt;
      mtntot = this.cgs === 0 ? this.totalInTxt : `${this.totInPer}<span style="font-size:14px;"> %</span>`;
    } else {
      d1 = this.totOut; d2 = this.totIn - this.totOut;
      titb2 = 'Nombre<span class="respdis13"> de sorties</span>';
      texttotparT = this.totIn > 1
        ? `${this.totalInTxt}<span class="respdis14"> entrées</span>`
        : `${this.totalInTxt}<span class="respdis14"> entrée</span>`;
      mper   = this.cgs === 0 ? this.totOutPer  : this.totalOutTxt;
      mtntot = this.cgs === 0 ? this.totalOutTxt : `${this.totOutPer}<span style="font-size:14px;"> %</span>`;
    }
    return { titb2, mper, mtntot, texttotparT, d1, d2 };
  }

  genG(a: SeriesKey): void {
    this.typGraph = a;
    this.dlg = 0;
    this.hoveredIdx = -1;

    const ser = this.series[a];
    const recent: RecentControlVm[] = a === 'S' ? this.recentS : a === 'In' ? this.recentIn : this.recentOut;
    const om = this.overmax;

    // Side-effects per series
    if (a === 'S') {
      this.respdis15 = 'Derniers contrôles ';
      this.mtndatapay = this.totalSTxt;
      this.noDataMsg = 'Aucun contrôle<span class="respdis50"> à afficher</span>';
    } else if (a === 'In') {
      this.respdis15 = 'Dernières entrées ';
      this.mtndatapay = this.totalInTxt;
      this.noDataMsg = 'Aucun contrôle<span class="respdis50"> d\'entrée<span class="respdis40"> à afficher</span></span>';
    } else {
      this.respdis15 = 'Dernières sorties ';
      this.mtndatapay = this.totalOutTxt;
      this.noDataMsg = 'Aucun contrôle<span class="respdis50"> de sortie<span class="respdis40"> à afficher</span></span>';
    }
    this.txtmtnpay = 'Total :';
    this.displayChange.emit(this.computeDisplay(a));

    // Activate bars
    this.activeBarsM = ser.M.bars;
    this.activeBarsH = ser.H.bars;
    this.activeBarsD = ser.D.bars;
    this.activeMaxM  = ser.M.maxCount;
    this.activeMaxH  = ser.H.maxCount;
    this.activeMaxD  = ser.D.maxCount;

    if (recent.length > 0) {
      this.dlg = 1;
    }

    // Graph widths (match legacy rules)
    if (om < 1) {
      this.wiG = ser.M.bars.length * 2;
      this.graphWidthM = this.wiG;
    }
    if (om < 2) {
      if (om >= 1) this.wiG = ser.H.bars.length * 12.9;
      this.graphWidthH = om >= 1 ? this.wiG : this.graphWidthM;
    }
    if (om < 3) {
      if (om >= 2) this.wiG = ser.D.bars.length * 28.73;
      this.graphWidthD = om >= 2 ? this.wiG : (om >= 1 ? this.graphWidthH : this.graphWidthM);
    }

    // Determine initial granularity
    if (om === 3) { this.activeGran = 'N'; this.zoomLabel = '...'; }
    else if (om === 2) { this.activeGran = 'J'; this.zoomLabel = 'Jours'; }
    else if (om === 1) { this.activeGran = 'H'; this.zoomLabel = 'Heures'; }
    else              { this.activeGran = 'M'; this.zoomLabel = 'Minutes'; }

    // Reset slider
    this.sliderTop  = this.DEF;
    this.vi         = this.DEF;
    this.lastmt     = this.DEF;
    this.defsize    = this.wiG;
    this.lastsize   = this.wiG;

    // Build listpay
    this.buildListPay(recent);

    // Scroll after view update
    setTimeout(() => this.applyGraphScroll(), 0);
  }

  onTypGraphChange(val: string): void {
    this.genG(val as SeriesKey);
  }

  // ── Recent events list ─────────────────────────────────────────────────────

  private buildListPay(recent: RecentControlVm[]): void {
    const total = recent.length;
    const showCount = Math.min(20, total);
    // Les N derniers controles, affiches du plus ancien au plus recent.
    const items = recent.slice(total - showCount);
    this.listpayItems = items.map((item, idx) => {
      // Zebra calee sur le rang affiche : l'alternance reste reguliere quel que
      // soit le nombre total de controles.
      const cls = idx % 2 === 0 ? 'itpay itpayg' : 'itpay';
      const dateStr = this.formatEventDate(item.date);
      return { cls, isIn: item.isIn, nomEtPrenom: item.nomEtPrenom, tplName: item.tplName, dateStr };
    });
    // Trailing empty item: alternate class from last item
    const lastCls = this.listpayItems.length
      ? (this.listpayItems[this.listpayItems.length - 1].cls === 'itpay' ? 'itpay itpayg' : 'itpay')
      : 'itpay itpayg';
    this.listpayTrailingCls = lastCls;
  }

  private formatEventDate(date: string): string {
    const parts = (typeof date === 'string') ? date.split(' ') : [];
    const datePart = parts[0] || '';
    const timePart = parts[1] || '';
    const hvm = timePart.split(':');
    const hours = hvm.length >= 2 ? `${hvm[0]}h${hvm[1]}` : '00h00';
    const dparts = datePart.split('-');
    return dparts.length >= 2 ? `${dparts[0]}/${dparts[1]} à ${hours}` : `${datePart} ${hours}`;
  }

  // ── Graph scroll ───────────────────────────────────────────────────────────

  private applyGraphScroll(): void {
    const cg = this.contgraphRef?.nativeElement;
    if (!cg || this.wiG <= 0) return;
    this.tox = this.wiG - cg.offsetWidth;
    cg.scrollLeft = Math.max(0, this.tox);
  }

  onGraphScroll(): void {
    const cg = this.contgraphRef?.nativeElement;
    if (!cg) return;
    this.tox = cg.scrollLeft;
    // Reposition floating tooltip labels
    const labG  = document.querySelector('.labG')  as HTMLElement | null;
    const dateG = document.querySelector('.dateG') as HTMLElement | null;
    const centerX = this.hoveredCenterX + (this.defsl - this.tox);
    if (labG)  this.placeFixed(labG,  centerX, this.hoveredBarTop - this.LABEL_LIFT, 'above');
    if (dateG) this.placeFixed(dateG, centerX, this.hoveredBarBottom, 'below');
  }

  onGraphMouseOver(): void {
    this.defsl = this.contgraphRef?.nativeElement?.scrollLeft ?? 0;
  }

  onGraphMouseOut(): void {
    const labG  = document.querySelector('.labG')  as HTMLElement | null;
    const dateG = document.querySelector('.dateG') as HTMLElement | null;
    if (labG)  { labG.style.opacity  = '0'; }
    if (dateG) { dateG.style.opacity = '0'; }
    this.hoveredIdx = -1;
    // Restore total display
    this.mtndatapay = this.typGraph === 'S' ? this.totalSTxt : this.typGraph === 'In' ? this.totalInTxt : this.totalOutTxt;
    this.txtmtnpay  = 'Total :';
  }

  // ── Bar hover ──────────────────────────────────────────────────────────────
  private hoveredCenterX = 0;
  private hoveredBarTop = 0;
  private hoveredBarBottom = 0;

  /** Ecart entre le sommet de la barre et le bas de la bulle du montant (px). */
  private readonly LABEL_LIFT = 8;

  /**
   * Place une infobulle en position:fixed a partir de coordonnees viewport.
   *
   * On ne suppose RIEN du bloc conteneur : un ancetre portant transform /
   * filter / backdrop-filter capture les elements position:fixed, et les
   * offsets deviennent alors relatifs a cet ancetre, pas au viewport. Plutot
   * que de chercher lequel, on remet les offsets a zero, on lit ou l'element
   * atterrit reellement, et on en deduit le decalage. La mesure absorbe du
   * meme coup les marges CSS et le transform propre a l'element.
   *
   * @param centerX abscisse viewport sur laquelle centrer la bulle
   * @param y       ordonnee viewport d'ancrage
   * @param anchor  'above' = bas de la bulle sur y, 'below' = haut sur y
   */
  private placeFixed(el: HTMLElement, centerX: number, y: number, anchor: 'above' | 'below'): void {
    el.style.left = '0px';
    el.style.top  = '0px';
    const r = el.getBoundingClientRect();
    el.style.left = `${centerX - r.width / 2 - r.left}px`;
    el.style.top  = `${(anchor === 'above' ? y - r.height : y) - r.top}px`;
  }

  onBarEnter(bar: BarEntry, idx: number, event: MouseEvent): void {
    this.hoveredIdx = idx;
    const barEl  = event.currentTarget as HTMLElement;

    // barEl est la colonne pleine hauteur (.barG) ; .g est la barre de valeur,
    // alignee en bas — c'est son sommet qui porte la bulle.
    const barRect = barEl.getBoundingClientRect();
    const gRect   = (barEl.querySelector('.g') as HTMLElement | null)?.getBoundingClientRect();
    this.hoveredCenterX   = barRect.left + barRect.width / 2;
    this.hoveredBarTop    = gRect && gRect.height > 0 ? gRect.top : barRect.bottom;
    this.hoveredBarBottom = barRect.bottom;

    const labG  = document.querySelector('.labG')  as HTMLElement | null;
    const dateG = document.querySelector('.dateG') as HTMLElement | null;
    const mtnlabG = document.getElementById('mtnlabG');

    const cumulStr = fmt(bar.cumul);
    if (mtnlabG) mtnlabG.innerHTML = cumulStr;
    // Bulle juste au-dessus du sommet de la barre (le caret pointe dessus).
    if (labG)  { this.placeFixed(labG, this.hoveredCenterX, this.hoveredBarTop - this.LABEL_LIFT, 'above'); labG.style.opacity = '1'; }
    // Date sous la ligne de base du graphe.
    if (dateG) { this.placeFixed(dateG, this.hoveredCenterX, this.hoveredBarBottom, 'below'); dateG.style.opacity = '1'; dateG.innerHTML = bar.date; }

    this.mtndatapay = cumulStr;
    // Label based on zoom granularity
    const lbl = this.activeGran === 'J' ? 'Total ce jour :' : this.activeGran === 'H' ? 'Total cette heure :' : 'Total à cette minute :';
    this.txtmtnpay = lbl;

    if (window.innerWidth > 820 && this.toScan > 0) {
      const sur = this.typGraph === 'Out' ? this.totIn : this.toScan;
      const scanperT = sur > 0 ? ((bar.cumul / sur) * 100).toFixed(0) : '0';
      const cgsDispatch = this.cgs === 0;
      const base = this.computeDisplay(this.typGraph);
      this.displayChange.emit({
        titb2:       base.titb2,
        d1:          base.d1,
        d2:          base.d2,
        mper:        cgsDispatch ? scanperT  : cumulStr,
        mtntot:      cgsDispatch ? cumulStr  : `${scanperT}<span style="font-size:14px;"> %</span>`,
        texttotparT: this.toScan > 1
          ? `${this.toScanTxt}<span class="respdis14"> contrôles</span>`
          : `${this.toScanTxt}<span class="respdis14"> contrôle</span>`,
      });
    }
  }

  onBarLeave(): void {
    this.hoveredIdx = -1;
    this.onGraphMouseOut();
    // Restore b2 to full-total display
    this.genGDisplay();
  }

  private genGDisplay(): void {
    // Re-emit full totals for b2 (called after hover ends, without rebuilding series)
    this.displayChange.emit(this.computeDisplay(this.typGraph));
  }

  barGradient(idx: number): string {
    if (this.hoveredIdx < 0) return 'linear-gradient(var(--ui-color-teal-200) 20%, var(--ui-color-teal-400))';
    if (idx < this.hoveredIdx)  return 'linear-gradient(var(--ui-color-teal-100) 20%, var(--ui-color-teal-300))';
    if (idx === this.hoveredIdx) return 'linear-gradient(var(--ui-color-teal-100) 20%, var(--ui-color-teal-200))';
    return 'linear-gradient(var(--ui-color-teal-200) 20%, var(--ui-color-teal-400))';
  }

  barHeightPct(count: number, max: number): string {
    const hc = max > 0 ? (count / max) * 100 : 0;
    return hc < 1 ? '1%' : hc + '%';
  }

  barWidthPct(len: number): string {
    return len > 0 ? (100 / len) + '%' : '0%';
  }

  // ── Slider drag (vertical, 8-62px, iso legacy lines 920-1020) ─────────────

  onSliderDown(e: MouseEvent): void {
    this.pm = e.pageY;
    this.wicgt = this.contgraphRef?.nativeElement?.offsetWidth ?? 0;
    this.setLabZoomOpacity(1);
    if (window.innerWidth <= 820) document.body.style.overflow = 'hidden';
  }

  onSliderTouchStart(e: TouchEvent): void {
    this.pm = e.touches[0].pageY;
    this.wicgt = this.contgraphRef?.nativeElement?.offsetWidth ?? 0;
    this.setLabZoomOpacity(1);
    if (window.innerWidth <= 820) document.body.style.overflow = 'hidden';
  }

  onB6Up(): void {
    if (this.pm !== 0) {
      this.vi = this.sliderTop;
      this.pm = 0;
      this.setLabZoomOpacity(0);
    }
    if (window.innerWidth <= 820) document.body.style.overflow = 'auto';
  }

  onZoomMouseMove(e: MouseEvent): void {
    if (this.pm !== 0 && this.dlg === 1) this.handleSlide(e.pageY);
  }

  onZoomTouchMove(e: TouchEvent): void {
    if (this.pm !== 0 && this.dlg === 1) this.handleSlide(e.touches[0].pageY);
  }

  private handleSlide(pageY: number): void {
    const em = pageY - this.pm;
    let mt = this.vi + em;
    if (mt < 8) mt = 8; else if (mt > 62) mt = 62;
    this.sliderTop = mt;

    const om = this.overmax;
    if (om === 3) return;

    const vt = mt / this.DEF;
    let newsize: number;
    let coefReg: number;
    const txtlabZ = document.querySelector('.txtlabZoom') as HTMLElement | null;

    if (om === 2) {
      newsize  = this.wiG * (vt ** 2);
      coefReg  = regulZoom(om, mt);
      this.activeGran = 'J';
      this.graphWidthD = newsize;
      if (txtlabZ) txtlabZ.innerHTML = 'Jours';
      this.zoomLabel = 'Jours';
    } else if (om === 1) {
      newsize = this.wiG * (vt ** 3);
      coefReg = regulZoom(om, mt);
      if (mt < 20) {
        this.activeGran = 'J'; this.graphWidthD = newsize;
        if (txtlabZ) txtlabZ.innerHTML = 'Jours';   this.zoomLabel = 'Jours';
      } else {
        this.activeGran = 'H'; this.graphWidthH = newsize;
        if (txtlabZ) txtlabZ.innerHTML = 'Heures';  this.zoomLabel = 'Heures';
      }
    } else {
      newsize = this.wiG * (vt ** 5);
      coefReg = regulZoom(om, mt);
      if (mt < 20) {
        this.activeGran = 'J'; this.graphWidthD = newsize;
        if (txtlabZ) txtlabZ.innerHTML = 'Jours';   this.zoomLabel = 'Jours';
      } else if (mt < 28) {
        this.activeGran = 'H'; this.graphWidthH = newsize;
        if (txtlabZ) txtlabZ.innerHTML = 'Heures';  this.zoomLabel = 'Heures';
      } else {
        this.activeGran = 'M'; this.graphWidthM = newsize;
        if (txtlabZ) txtlabZ.innerHTML = 'Minutes'; this.zoomLabel = 'Minutes';
      }
    }

    // Invert coefReg when zooming out (iso legacy line 1001-1003)
    if (mt < this.lastmt) coefReg = -coefReg + 2.01;

    const coefposl = (this.tox + this.wicgt / 2) / (newsize * coefReg);
    const difsize  = newsize - this.lastsize;
    const sl       = this.tox + difsize * coefposl;

    // mllab: center of one bar (for labG margin)
    const labG = document.querySelector('.labG') as HTMLElement | null;
    if (labG) {
      const mllab = this.activeGran === 'J'
        ? newsize / Math.max(1, this.activeBarsD.length) / 2
        : this.activeGran === 'H'
          ? newsize / Math.max(1, this.activeBarsH.length) / 2
          : newsize / Math.max(1, this.activeBarsM.length) / 2;
      labG.style.marginLeft = mllab + 'px';
    }

    this.lastmt   = mt;
    this.lastsize = newsize;
    setTimeout(() => {
      if (this.contgraphRef) this.contgraphRef.nativeElement.scrollLeft = Math.max(0, sl);
      this.tox = sl;
    }, 0);

    const labZoom = document.querySelector('.labZoom') as HTMLElement | null;
    if (labZoom) labZoom.style.marginTop = mt + 'px';
  }

  private setLabZoomOpacity(v: number): void {
    const labZoom = document.querySelector('.labZoom') as HTMLElement | null;
    if (labZoom) labZoom.style.opacity = String(v);
  }

  // ── Navigation ─────────────────────────────────────────────────────────────
  onRefresh(): void { this.refresh.emit(); }
  onGoParticipants(): void { this.router.navigateByUrl('/liste-des-participants'); }
}
